(function (root, factory) {
  'use strict';
  var exported = factory();
  if (typeof module === 'object' && module.exports) module.exports = exported;
  root.FBGroupGiftsProduct = exported;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  function canonical(value) {
    value = String(value || '');
    return /^\d+$/.test(value) ? 'gid://shopify/ProductVariant/' + value : value;
  }
  function create(options) {
    var generation = 0, disposed = false, pendingAdd = null, pendingUndo = null;
    var state = { handle: null, product: null, variant: null, suggestion: null, loading: false, saving: false, error: null, saved: null, removed: false };
    function changed() { if (!disposed && options.onChange) options.onChange(state); }
    function key(scope, body) { return options.key(scope, body); }
    async function open(handle, requested) {
      if (disposed || state.saving) return;
      var current = ++generation;
      state.handle = handle; state.product = null; state.variant = null; state.suggestion = null;
      state.saved = null; state.removed = false; state.error = null; state.loading = true;
      pendingAdd = null; pendingUndo = null; changed();
      try {
        var response = await options.request('/shop/' + encodeURIComponent(handle) + (requested ? '?variantId=' + encodeURIComponent(canonical(requested)) : ''));
        if (disposed || current !== generation) return;
        state.product = response.product; state.suggestion = response.suggestion;
        state.variant = requested ? response.product.variants.find(function (v) { return canonical(v.variantId) === canonical(requested); }) || null : response.product.variants[0] || null;
        if (!state.variant) state.error = new Error('This option is unavailable. Choose another option or return to gifts.');
      } catch (error) { if (!disposed && current === generation) state.error = error; }
      finally { if (!disposed && current === generation) { state.loading = false; changed(); } }
    }
    async function mutate(path, body, undo) {
      var current = generation;
      state.saving = true; state.error = null; changed();
      try {
        var response = await options.request(path, body);
        if (disposed || current !== generation) return;
        if (undo) { state.removed = true; state.saved = null; pendingAdd = null; pendingUndo = null; }
        else state.saved = response;
        if (options.onGroup) options.onGroup(response.group);
      } catch (error) {
        if (!disposed && current === generation) {
          state.error = error;
          if (undo && error.code === 'EDIT_CONFLICT') {
            state.saved.change.undoable = false; pendingUndo = null;
            state.error = new Error('This idea changed after it was added. Review the current shortlist before removing it.');
            try {
              var latest = await options.request('');
              if (disposed || current !== generation) return;
              state.saved.group = latest.group;
              var idea = latest.group.suggestions.find(function (s) { return s.id === state.saved.change.suggestionId; });
              state.saved.change.currentState = idea ? 'active' : 'archived';
              if (options.onGroup) options.onGroup(latest.group);
            } catch (reloadError) { if (!disposed && current === generation) state.error = Object.assign(new Error('This idea changed. Refresh the shortlist to review its current state.'), { code: reloadError.code, status: reloadError.status }); }
          }
        }
      }
      finally { if (!disposed && current === generation) { state.saving = false; changed(); } }
    }
    return {
      state: state, open: open,
      select: function (variantId) { return open(state.handle, variantId); },
      add: function () {
        if (disposed || state.loading || state.saving || !state.variant || state.saved) return;
        if (!pendingAdd) {
          pendingAdd = { productHandle: state.handle, variantId: state.variant.variantId };
          if (state.suggestion && state.suggestion.archivedAt) pendingAdd.expectedSuggestionVersion = state.suggestion.version;
          pendingAdd.idempotencyKey = key('suggestion', pendingAdd);
        }
        return mutate('/suggestions', pendingAdd, false);
      },
      undo: function () {
        var saved = state.saved, change = saved && saved.change;
        if (disposed || state.saving || !change || !change.undoable || change.currentState !== 'active') return;
        if (!pendingUndo) {
          pendingUndo = { expectedSuggestionVersion: change.suggestionVersion, expectedPlanVersion: saved.group.plan.version };
          pendingUndo.idempotencyKey = key('archive', pendingUndo);
        }
        return mutate('/suggestions/' + encodeURIComponent(change.suggestionId) + '/archive', pendingUndo, true);
      },
      dispose: function () { disposed = true; generation++; pendingAdd = null; pendingUndo = null; state.product = null; state.variant = null; state.suggestion = null; state.saved = null; state.error = null; state.loading = false; state.saving = false; }
    };
  }
  return { create: create, canonical: canonical };
});
